// 跳转系统
const env = process.env.NODE_ENV
const system = env == 'production'
var mixin = {
    methods: {
        goMacro() {
            if (system) {
                window.open('http://lightdata.tjresearch.cn')
            } else {
                window.open('http://macro.tj.cn')
            }
        },
        goMacro1(type) {
            if (system) {
                window.open('http://lightdata.tjresearch.cn/#/introLogin?from=' + type)
            } else {
                window.open('http://macro.tj.cn/#/introLogin?from=' + type)
            }
        },
        goCompany() {
            if (system) {
                window.open('http://qiyuce.tjresearch.cn')
            } else {
                window.open('http://qiyuce.tj.cn')
            }
        }

    }
}
export default mixin